import Button from "@mui/material/Button";
import {useEffect, useState} from "react";
import * as React from "react";
import {getClientServiceRequestsDetailsByClientID, getServiceRequests} from "../../utilities/ClientApi";
import keycloak from "../../Keycloak";
import Box from '@mui/material/Box';
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import DeleteModal from "../General/DeleteServiceRequest";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Chip from '@mui/material/Chip';
import BulletChart from "./BulletChart";
import {useLocation} from "react-router-dom";
import {useClient} from "../../utilities/ClientProvider";

const ServiceRequestList = () => {
    const { client } = useClient(); // Get client from context
    const [clientServiceRequestDetails, setClientServiceRequestDetails] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openModal, setOpenModal] = useState(false);
    const location = useLocation();
    const [serviceRequestId, setServiceRequestId] = useState(0);
    const searchParams = new URLSearchParams(location.search);
    const clientId = searchParams.get('clientId');
    console.log(clientId);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let serviceRequests;
                if (client === "all") {
                    serviceRequests = await getServiceRequests(keycloak.token);
                    if (serviceRequests.length < 1) {
                        document.getElementById("NoServiceRequestText").style.display = "block";
                        document.getElementById("showServiceRequestBox").style.display = "none";
                    } else {
                        document.getElementById("showServiceRequestBox").style.display = "block";
                        document.getElementById("NoServiceRequestText").style.display = "none";
                    }
                } else {
                    serviceRequests = await getClientServiceRequestsDetailsByClientID(client, keycloak.token);
                    if (serviceRequests.length < 1) {
                        document.getElementById("NoServiceRequestText").style.display = "block";
                        document.getElementById("NoServiceRequestText").innerText = "There are no active service requests for this client";
                        document.getElementById("showServiceRequestBox").style.display = "none";
                    } else {
                        document.getElementById("showServiceRequestBox").style.display = "block";
                        document.getElementById("NoServiceRequestText").style.display = "none";
                    }
                }
                serviceRequests.forEach((client) => {
                    serviceRequests.sort((a, b) => a.clientName.localeCompare(b.clientName));
                    client.serviceRequestBudgetSummaryList.sort((a, b) => a.serviceRequestName.localeCompare(b.serviceRequestName));
                });
                setClientServiceRequestDetails(serviceRequests);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [client]);

    useEffect(() => {
        function toggleColumnVisibility() {
            const columnResponsive = document.querySelectorAll(".responsiveCell");
            const hoursMobile = document.querySelectorAll(".hoursMobile");
            const chipProject = document.querySelectorAll(".chipProject");

            if (window.innerWidth <= 1023) {
                const tables = document.querySelectorAll(".generateTables");

                function updateHoursForTable(table) {
                    const hoursResponsive = table.querySelectorAll(".hoursMobile");

                    const headerRow = table.querySelector("thead tr");
                    let remainingColumnIndex = -1;
                    for (let i = 0; i < headerRow.children.length; i++) {
                        const headerCell = headerRow.children[i];
                        if (headerCell.textContent.trim() === "Remaining") {
                            remainingColumnIndex = i;
                            break;
                        }
                    }

                    if (remainingColumnIndex !== -1) {
                        const tbody = table.querySelector("tbody");
                        for (let rowIndex = 0; rowIndex < tbody.children.length; rowIndex++) {
                            const row = tbody.children[rowIndex];
                            const cell = row.children[remainingColumnIndex];

                            const value = cell.textContent.trim();

                            const hoursCell = hoursResponsive[rowIndex];
                            hoursCell.style.display = "block";
                            hoursCell.textContent = `Remaining Balance: ${value}`;
                        }
                    }
                }

                tables.forEach((table) => {
                    updateHoursForTable(table);
                });
                columnResponsive.forEach((cell) => {
                    cell.style.display = "none";
                });
                chipProject.forEach((cell) => {
                    cell.style.display = "none";
                });
            }

            else {
                columnResponsive.forEach((cell) => {
                    cell.style.display = "table-cell";
                });
                hoursMobile.forEach((cell) => {
                    cell.style.display = "none";
                });
            }
        }

        toggleColumnVisibility();
        window.addEventListener("resize", toggleColumnVisibility);

        return () => {
            window.removeEventListener("resize", toggleColumnVisibility);
        };
    }, []);

    const columns = [
        { id: 'allocatedBudget', label: 'Allocated Budget', minWidth: 100 },
        { id: 'budgetUsed', label: 'Used', minWidth: 130},
        { id: 'hoursBar', label: ' ', minWidth: 140 },
        { id: 'budgetRemaining', label: 'Remaining', minWidth: 135},
        { id: 'billables', label: 'Estimated Billables', minWidth: 150},
        { id: 'view', label: 'Action', minWidth: 100},
    ];


    const getProjectType = (type) => {
        if (type === 0) {
            return 'Team Augmentation';
        } else if (type === 1){
            return 'Fixed Cost Project';
        }
        else if (type === 2){
            return 'Support & Maintenance'
        }
        else if (type === 3) {
            return 'Dedicated Product Development Team';
        }
        else if (type === 4) {
            return 'Time & Materials';
        }
    }

    const handleClick = (event, clientId, serviceRequestId, totalHours, hoursUsed, clientName, projectId, serviceRequestName, harvestClientId) => {
        setAnchorEl(event.currentTarget);
        setServiceRequestId(serviceRequestId);
        localStorage.setItem('serviceRequestListSelectedClientId', clientId);
        localStorage.setItem('serviceRequestListSelectedClientName', clientName);
        localStorage.setItem('serviceRequestListSelectedServiceRequestId', serviceRequestId);
        localStorage.setItem('serviceRequestListSelectedServiceRequestName', serviceRequestName);
        localStorage.setItem('serviceRequestListSelectedHarvestClientId', harvestClientId);
        localStorage.setItem('serviceRequestListTotalHours', totalHours);
        localStorage.setItem('serviceRequestListHoursUsed', hoursUsed);
        localStorage.setItem('serviceRequestProjectId', projectId);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const typographyStyles = {
        backgroundColor: '#F3F3F3',
        height: '50px',
        width: "180px",
        '&:hover': {
            backgroundColor: '#F79016'
        },
    };

    const buttonStyles = {
        color: 'black',
        '&:hover': {
            color: 'white',
            backgroundColor: 'Transparent'
        },
        width: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        textTransform: 'none',
    };

    return (
        <div style={{padding: "20px 5%"}} data-testid='OuterMostDiv'>
            <div>
                <div>
                    <h2 data-testid='ServiceRequestListHeading'
                        style={{fontFamily: 'poppins', fontWeight: '42px'}}>Service Request List</h2>
                    <div id="NoServiceRequestText" data-testid='NoServiceRequestText'
                         style={{fontFamily: 'poppins', display: "none"}}>You do not have any service requests.
                    </div>
                </div>
                <Box id="showServiceRequestBox" data-testid='showServiceRequestBox'>
                    {clientServiceRequestDetails.map((data, index) => (
                        <TableContainer sx={{ borderRadius: "4px"}} key={index}>
                            <Table className={"generateTables"} sx={{ backgroundColor: "#FFFFFF"}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" style={{ width: '250px', fontSize: '24px', marginLeft:"80px", borderBottom: 'none', fontFamily: 'poppins'}}>
                                            {data.clientName}
                                        </TableCell>
                                        {columns.map((column) => (
                                            column.id === "billables"
                                                ? (
                                                    <TableCell
                                                        key={column.id}
                                                        align={"right"}
                                                        className={
                                                            (keycloak.hasResourceRole("account_manager") ||
                                                            keycloak.hasResourceRole("delivery_manager") ||
                                                            keycloak.hasResourceRole("system_admin")
                                                                ? "responsiveCell" : "d-none")}
                                                        style={{ minWidth: column.minWidth, fontSize: '14px', borderBottom: 'none', }}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                                : column.id === "view"
                                                    ? (
                                                        <TableCell
                                                            key={column.id}
                                                            align={"center"}
                                                            className={"responsiveCell"}
                                                            style={{ minWidth: column.minWidth, fontSize: '14px', borderBottom: 'none', }}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    )
                                                    : (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            className={"responsiveCell"}
                                                            style={{ minWidth: column.minWidth, fontSize: '14px', borderBottom: 'none', }}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    )
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.serviceRequestBudgetSummaryList.map((serviceRequest, subIndex) => {
                                        const isLastRow = subIndex === data.serviceRequestBudgetSummaryList.length - 1;

                                        function formatCurrency()
                                        {
                                            const calculatedCostInRands = (serviceRequest.calculatedCost).toLocaleString("en-ZA", {
                                                style: "currency",
                                                currency: "ZAR",
                                            });

                                            return calculatedCostInRands.replace(/,(?=\d\d$)/, '.');
                                        }
                                        return (
                                            <TableRow key={serviceRequest.serviceRequestId} sx={{ borderBottom: isLastRow ? '20px solid #F6F6F6' : '5px solid white'}}>
                                                <TableCell style={{ fontFamily: 'poppins' }}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        {serviceRequest.serviceRequestName}
                                                        <div className={"hoursMobile"} style={{ marginTop: "6px" }}></div>
                                                    </div>
                                                    <Chip style={{ height: "22px", fontSize: '12px' }} label={getProjectType(serviceRequest.type)} variant="outlined" />
                                                </TableCell>
                                                <TableCell className={"responsiveCell"} align="left" style={{ fontSize: '20px', fontWeight: "bold" }}>{serviceRequest.allocatedBudget}hrs</TableCell>
                                                <TableCell className={"responsiveCell"} align="left" style={{ fontSize: '20px', fontWeight: "bold" }}>{serviceRequest.budgetUsed}hrs</TableCell>
                                                <TableCell className={""} align="left">
                                                    <BulletChart serviceRequestInfo={serviceRequest} chartType={'Thin'} projectType={serviceRequest.type}/>
                                                </TableCell>
                                                <TableCell className={"responsiveCell"} align="left" style={{ fontSize: '20px', fontWeight: "bold" }}>{serviceRequest.budgetRemaining}hrs</TableCell>
                                                <TableCell align="right" style={{ fontSize: '20px', fontWeight: "bold" }} className={
                                                    (keycloak.hasResourceRole("account_manager") ||
                                                        keycloak.hasResourceRole("delivery_manager") ||
                                                        keycloak.hasResourceRole("system_admin")
                                                        ? "responsiveCell" : "d-none")
                                                }>{formatCurrency()}</TableCell>
                                                <TableCell align="center" style={{ borderRadius: '50px' }}>
                                                    <div>
                                                        <Button variant="text" onClick={(event) => handleClick(event, data.clientId, serviceRequest.serviceRequestId, serviceRequest.allocatedBudget, serviceRequest.budgetUsed, data.clientName, serviceRequest.projectId, serviceRequest.serviceRequestName, data.harvestClientId)} style={{ color: 'black'}}>
                                                            <MoreVertOutlinedIcon />
                                                        </Button>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ))}
                    <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} elevation={1}  >
                        <Typography sx={ typographyStyles }>
                            <Button href='/ServiceRequestDashboard' sx={buttonStyles} data-testid={"viewServiceRequestAction"}>View</Button>
                        </Typography>
                        <Typography sx={ typographyStyles }
                                    className={
                                        (keycloak.hasResourceRole("system_admin") ||
                                            keycloak.hasResourceRole("account_manager") ||
                                            keycloak.hasResourceRole("delivery_manager") ||
                                            keycloak.hasResourceRole("internal_user") ||
                                            keycloak.hasResourceRole("client_admin"))
                                            ? "d-block" : "d-none"
                                    }
                        >
                            <Button href={`EditServiceRequest?serviceRequestId=${serviceRequestId}`} data-testid={"editServiceRequestAction"} sx={buttonStyles}>Edit</Button>
                        </Typography>
                        <Typography sx={ typographyStyles }
                                    className={
                                        (keycloak.hasResourceRole("system_admin") ||
                                            keycloak.hasResourceRole("account_manager") ||
                                            keycloak.hasResourceRole("delivery_manager") ||
                                            keycloak.hasResourceRole("internal_user") ||
                                            keycloak.hasResourceRole("client_admin"))
                                            ? "d-block" : "d-none"
                                    }
                        >
                            <Button sx={buttonStyles} data-testid={"deleteServiceRequestAction"} onClick={() => {setOpenModal(true);}}>Delete</Button>
                        </Typography>
                    </Popover>
                    <DeleteModal open={openModal} onClose={() => setOpenModal(false)}/>
                </Box>
            </div>
        </div>
    );
};

export default ServiceRequestList